import React, {Component} from 'react';
import {connect} from "react-redux";
import {dbase} from "../../firebase"
import RecordingCard from "../unit/recordings/recordingcard/RecordingCard";
import {byPropKey} from "../utils";
import Throbber from "../miscellaneous/Throbber";
import {getUnit} from "../unit/utils";
import ScrollToTop from 'react-scroll-up';
import InfiniteScroll from "react-infinite-scroll-component";
import {Stagger} from 'react-animation-components';

// TODO: Implement {@link https://eviltrout.com/2013/02/16/infinite-scrolling-that-works.html}
const INITIAL_STATE = {
    recordings: [],
    scrollerRecordings: [],
    referenceToLatestKey: null,
    error: null
};

const LOAD_AMOUNT = 12;
const MAX_LOAD_AMOUNT = LOAD_AMOUNT * 10;

/**
 * A list of recordings to be displayed
 * @param recordings json that are passed into the component.
 */
class RecordingsList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...INITIAL_STATE
        };
    }
    componentDidMount() {
        this.setState(() => ({
            ...INITIAL_STATE
        }));
        if (this.props.units && Object.keys(this.props.units).length > 0) {
            this.loadAllRecordings(this.props.units)();
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState(() => ({
            ...INITIAL_STATE
        }));
        if (this.props.units && Object.keys(this.props.units).length > 0) {
            this.loadAllRecordings(this.props.units)();
        }
    }

    /**
     * Loads all recordings belonging to the user onto
     * {@code recordings} and sorts them by date then
     * slices them up to the {@code MAX_LOAD_AMOUNT}
     * to be displayed on the screen.
     *
     * @see getRecordingsOnceUpToLimit and
     * @see getRecordingsOnceUpToLimitEndOn
     * for more information.
     *
     * Data loading grabs all from firebase then
     *
     * There was an older implmentation based off of
     * {@link https://hackernoon.com/infinite-scrolling-in-firebase-e28bfbc53578}.
     *
     * If you can think of a better way (THAT WORKS),
     * by all means, upgrade this implementation.
     */
    loadAllRecordings = (units) => () => {
        let recordings = [];
        let unitPromises = [];
        // 1. Get all the unit's respective recordings
        Object.keys(units).map(unitKey => {
            const unit = getUnit(unitKey, units[unitKey]);
            // 2. Store the promise so we can sort once all promises have been successfully completed.
            unitPromises.push(dbase.getRecordingsOnceUpToLimit(unitKey, MAX_LOAD_AMOUNT)
                .then(snapshot => {
                    // 3. Sort the loaded data based on the snapshot's key values. (Latest First)
                    let arrayOfKeys = Object.keys(snapshot.val())
                        .sort()
                        .reverse();

                    // 4. Map the keys to {@code results}
                    let results = arrayOfKeys.map(key =>
                        <RecordingCard
                            key={key}
                            recordingID={key}
                            recordingData={snapshot.val()[key]}
                            selectedUnit={unit}
                        />
                    );
                    // 5. Concat the {@code results} to {@code recordings}
                    recordings = recordings.concat(results);
                })
                .catch(error => {
                    this.setState(byPropKey('error', error));
                }));
            return null;
        });
        // 6. Wait for all unit recordings to load before sorting all of them by date.
        Promise.all(unitPromises)
            .then(() => {
                // 7. Sort recordings by date
                recordings.sort((a, b) => (b.props.recordingData.date - a.props.recordingData.date));
                // 8. Calculate the next reference point to the next set in the infinite scroller
                const nextReference = Math.min(recordings.length, LOAD_AMOUNT);
                // 9. Update recordings to only the maximum loadable amount, {@code MAX_LOAD_AMOUNT}
                this.setState(byPropKey('recordings', recordings.slice(0, MAX_LOAD_AMOUNT)));
                // 10. Load the first set of {@code scrollerRecordings} and update the reference to {@code referenceToLatestKey}
                this.setState(byPropKey('scrollerRecordings', recordings.slice(0, nextReference)));
                this.setState(byPropKey('referenceToLatestKey', nextReference));
            });
    };

    /**
     * Loads the {@code scrollerRecordings} on the screen when
     * called by collecting from the next reference or the maximum
     * length of {@code recordings}.
     */
    loadRecordings = () => {
        if (this.state.referenceToLatestKey) {
            const nextRef = Math.min(this.state.referenceToLatestKey + LOAD_AMOUNT, this.state.recordings.length);
            let results = this.state.recordings.slice(
                this.state.referenceToLatestKey,
                nextRef
            );
            setTimeout(() => {
                this.setState(byPropKey('scrollerRecordings', this.state.scrollerRecordings.concat(results)));
                this.setState(byPropKey('referenceToLatestKey', nextRef));
            }, 750);
        }
    };

    render() {
        return (
            <div>
                <InfiniteScroll
                    scrollThreshold={0.9}
                    refreshFunction={this.loadAllRecordings(this.props.units)}
                    next={this.loadRecordings}
                    hasMore={this.state.recordings.length > this.state.scrollerRecordings.length}
                    loader={<div className="text-center"><Throbber/></div>}
                    endMessage={<div className="text-center">To view more recordings, select a vehicle.</div>}
                >
                    <Stagger className="row">
                        {this.state.scrollerRecordings}
                    </Stagger>
                </InfiniteScroll>
                <ScrollToTop showUnder={200}>
                    <button
                        className="btn btn-secondary"
                        style={{opacity: 0.5}}
                    >
                        <i className="fas fa-caret-up"/>
                    </button>
                </ScrollToTop>
            </div>
        );
    }
}

/**
 * Map Redux {@param state} to component props
 */
const mapStateToProps = (state) => ({
    units: state.unitsState.units
});

export default connect(mapStateToProps)(RecordingsList);



// WEBPACK FOOTER //
// ./src/components/dashboard/RecordingsList.jsx